module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f466-1f3fb.9e057ae8.svg";